import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const savedLocale = localStorage.getItem('m7_lang') || window.navigator.language || 'en';

const i18n = new VueI18n({
    locale: savedLocale,
    fallbackLocale: 'en',
    messages: {
        ja: require(`./locale/ja.json`),
        en: require(`./locale/en.json`),
    },
})

Vue.i18n = i18n

// Language file for each service
const ja = require.context('./locale', true, /ja.json/)
ja.keys().forEach((key) => {
    Vue.i18n.mergeLocaleMessage('ja', ja(key))
})
const en = require.context('./locale', true, /en.json/)
en.keys().forEach((key) => {
    Vue.i18n.mergeLocaleMessage('en', en(key))
})

export default i18n
